import { render, staticRenderFns } from "./SiftComp.vue?vue&type=template&id=53750e58&scoped=true&"
import script from "./SiftComp.vue?vue&type=script&lang=js&"
export * from "./SiftComp.vue?vue&type=script&lang=js&"
import style0 from "./SiftComp.vue?vue&type=style&index=0&id=53750e58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53750e58",
  null
  
)

export default component.exports